import React from 'react';

const SignOut = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6.14286 20H13C13.303 19.9997 13.5935 19.8791 13.8077 19.6649C14.022 19.4506 14.1425 19.1601 14.1429 18.8571V17.1429H13V18.8571H6.14286V5.14286H13V6.85714H14.1429V5.14286C14.1425 4.83986 14.022 4.54937 13.8077 4.33512C13.5935 4.12087 13.303 4.00035 13 4H6.14286C5.83986 4.00035 5.54937 4.12087 5.33512 4.33512C5.12087 4.54937 5.00035 4.83986 5 5.14286V18.8571C5.00035 19.1601 5.12087 19.4506 5.33512 19.6649C5.54937 19.8791 5.83986 19.9997 6.14286 20Z'
        fill='black'
      />
      <path
        d='M14.4776 14.6206L16.5268 12.5714H8.42847V11.4286H16.5268L14.4776 9.37941L15.2856 8.57141L18.7142 12L15.2856 15.4286L14.4776 14.6206Z'
        fill='black'
      />
    </svg>
  );
};

export default SignOut;
